<template>
  <v-card flat outlined>
    <v-card-actions>
      <strong class="subtitle-1"><i>Test Pricing</i></strong>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th>Type</th>
            <th v-for="category in categories" :key="category.uuid">{{ category.name }}</th>
            <th>Default</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="test in form" :key="test.uid">
            <td>
<!--              <v-chip color="error" class="white&#45;&#45;text" label small>{{testTypes.find(v=> v.uuid === test.test_type_uuid).name}}</v-chip>-->
              <v-chip color="error" class="white--text" label small>{{test.test_type.name}}</v-chip>
              {{test.test_type.description}}
            </td>
            <td v-for="(category, index) in categories" :key="index">
              <v-text-field v-if="test.category_prices && test.category_prices[category.uuid]" v-model="test.category_prices[category.uuid].price" prefix="$" :label="category.name" placeholder="0.00" clearable></v-text-field>
            </td>
            <td>
              <v-text-field v-model="test.default_pricing" prefix="$" label="Default" placeholder="0.00"></v-text-field>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
<!--      {{form}}-->
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "BillingPricing",
  components: {},
  data: () => ({
    loading: false,
    loadingError: false,
    form: [],
  }),
  watch:{
    form:{
      deep: true,
      handler(v){
        console.log('saw the change')
        this.originalTestPricing = v
      }
    },
    watch:{
      testType(v){
        if(v && !this.loading){
          this.load();
        }
      }
    }
  },
  computed: {
    testTypes(){
      return this.$store.$db().model('sampleTestTypes').all()
    },
    categories(){
      return this.$store.$db().model('sampleCertTypeCategories').all()
    },
    originalTestPricing: {
      get: function(){
        return this.$store.$db().model('billingTestPrices').query().with('test_type').get();
      },
      set: function(v){
        return this.$store.$db().model('billingTestPrices').insertOrUpdate({data: v})
      }
    }
  },
  mounted(){
    this.load();
  },
  methods: {
    async load(){
      await this.$store.$db().model('billingTestPrices').deleteAll();
      console.log('loading?')
      this.loading = true;
      this.loadingError = false
      this.form = []
      try{
        // (await this.$store.$db().model('billingPackages').add()).billingPackages[0]
        await this.$store.$db().model('billingTestPrices').load();
        let newItems = this.$store.$db().model('sampleTestTypes').query().where((v) => !this.originalTestPricing.map(item => item.test_type_uuid).includes(v.uuid)).get();
        for(let item of newItems){
          let newItem = await this.$store.$db().model('billingTestPrices').newItem();
          newItem.uid = item.uuid;
          newItem.test_type_uuid = item.uuid;
          newItem.default_pricing = 0;
          newItem.category_prices = this.categories.reduce((obj, category) => {
            obj[category.uuid] = {
              price: null,
            }
            return obj
          },{})
          this.$store.$db().model('billingTestPrices').insertOrUpdate({data: newItem});
        }
        await this.reset();
      }catch(e){
        console.log(e)
        this.loadingError = true;
      }finally{
        this.loading = false;
      }
    },
    async reset(){
      for(let item of this.originalTestPricing){
        if(!item.category_prices || Object.keys(item.category_prices).length === 0){
          item.category_prices = this.categories.reduce((obj, category) => {
            obj[category.uuid] = {
              price: null,
            }
            return obj
          },{})
          await this.$store.$db().model('billingTestPrices').insertOrUpdate({data: item});
        }
      }
      const original = JSON.stringify(this.originalTestPricing);
      // if any items in the original does not have category_prices or it is empty, we need to add them

      this.form = JSON.parse(original);
      this.sortForm()
    },
    sortForm(){
      this.form.sort((a,b) => {
        if(a.test_type && b.test_type){
          return a.test_type.display_order - b.test_type.display_order
        }
        return a.uid & b.uid
      })
    }
  }
}
</script>

<style scoped>

</style>
